const loadingStatePlugin = {
  install: (app, { store }) => {
    if (!store) {
      throw new Error('Please provide vuex store.')
    }

    app.config.globalProperties.$loadingState = {
      start: function (message = null) {
        store.commit('loading/startLoading', message)
      },
      stop: function () {
        store.commit('loading/stopLoading')
      },
      reset: function () {
        store.commit('loading/resetLoading')
      },
      setMessage: function (message) {
        store.commit('loading/setLoadingMessage', message)
      }
    }
  }
}
export default loadingStatePlugin
